import React from 'react';
import { BookOpen, Calendar, FileText, CheckSquare, Lightbulb, Gamepad2, Library, Music, Star } from 'lucide-react';
export function Offer() {
  const products = [{
    icon: BookOpen,
    title: 'Manual para Padres',
    desc: 'Guía completa con el método paso a paso'
  }, {
    icon: Calendar,
    title: 'Plan 21 Días',
    desc: 'Actividades diarias de 10 minutos listas para usar'
  }, {
    icon: FileText,
    title: 'Workbook Imprimible',
    desc: 'Ejercicios para practicar con tu hijo'
  }, {
    icon: CheckSquare,
    title: 'Checklist de Progreso',
    desc: 'Para ver el avance semana a semana'
  }, {
    icon: Lightbulb,
    title: 'Guía Anti Frustración',
    desc: 'Qué hacer cuando aparece el bloqueo'
  }];
  const bonuses = [{
    icon: Gamepad2,
    title: 'Juegos Fonológicos',
    desc: 'Actividades lúdicas para reforzar los sonidos'
  }, {
    icon: Calendar,
    title: 'Calendario Visual',
    desc: 'Para que tu hijo vea su propio progreso'
  }, {
    icon: Library,
    title: 'Mini Biblioteca Inicial',
    desc: 'Lecturas cortas para los primeros logros'
  }, {
    icon: Music,
    title: 'Audio Calmante',
    desc: 'Para crear el ambiente ideal antes de cada sesión'
  }];
  return <section className="w-full bg-cream-dark py-20 md:py-28 px-4" data-id="element-75">
      <div className="max-w-5xl mx-auto" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4" data-id="element-78">
            Todo lo que recibís hoy
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-79"></div>
        </div>

        {/* Main Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-80">
          {products.map((item, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-cream hover:border-olive/30 transition-colors" data-id="element-81">
              <item.icon className="w-8 h-8 text-olive mb-4" data-id="element-82" />
              <h3 className="text-lg font-bold text-dark font-serif mb-2" data-id="element-83">
                {item.title}
              </h3>
              <p className="text-dark/70 text-sm" data-id="element-84">{item.desc}</p>
            </div>)}
        </div>

        {/* Bonuses */}
        <div className="mb-16" data-id="element-85">
          <h3 className="text-2xl md:text-3xl font-serif text-gold font-bold text-center mb-8" data-id="element-86">
            + 4 Bonos Especiales
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-87">
            {bonuses.map((item, index) => <div key={index} className="bg-cream p-6 rounded-xl border-l-4 border-gold flex items-start space-x-4" data-id="element-88">
                <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-89">
                  <item.icon className="w-6 h-6 text-gold" data-id="element-90" />
                </div>
                <div data-id="element-91">
                  <h4 className="font-bold text-dark font-serif" data-id="element-92">
                    {item.title}
                  </h4>
                  <p className="text-sm text-dark/70" data-id="element-93">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Pricing */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl text-center max-w-2xl mx-auto mb-16 border border-cream-dark relative overflow-hidden" data-id="element-94">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-olive to-terracotta" data-id="element-95"></div>

          <p className="text-dark/50 line-through text-lg mb-2" data-id="element-96">
            Valor real: $62.900
          </p>
          <div className="flex items-center justify-center space-x-2 mb-4" data-id="element-97">
            <span className="text-5xl md:text-6xl font-bold text-terracotta font-serif" data-id="element-98">
              $17.900
            </span>
          </div>
          <p className="text-olive font-medium uppercase tracking-wide text-sm mb-8" data-id="element-99">
            Acceso inmediato · Descarga instantánea
          </p>

          <button onClick={() => window.open('https://www.gaiadigitalpro.com/checkouts/cn/hWN91detKUA3JZvySec9CenJ/es-ar?_r=AQABrOvx_mroREqaZDGTff6UkVA7_iuSpYNGcQFEgzuoo40&preview_theme_id=163059597347', '_blank')} className="w-full md:w-auto hover:bg-terracotta-light text-white font-serif text-xl px-12 py-4 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 bg-[#6FC628]" data-id="element-100">
            Quiero activar la lectura en casa
          </button>
        </div>

        {/* Reviews */}
        <div className="max-w-4xl mx-auto" data-id="element-101">
          <div className="text-center mb-8" data-id="element-102">
            <h3 className="text-2xl font-serif text-dark mb-2" data-id="element-103">
              Lo que dicen las familias
            </h3>
            <div className="flex justify-center space-x-1" data-id="element-104">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-105" />)}
            </div>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/vTiDPu3tPzChTgqgociraZ/resenas.png" alt="Reseñas de familias" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-106" />
        </div>
      </div>
    </section>;
}